import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(({ spacing, palette }) => ({
  textButton: {
    textTransform: "none",
    padding: 0,
    maxWidth: "90%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    overflow: "hidden",
  },
  fileName: () => ({
    color: palette.contrastText.main,
    lineHeight: 1.1,
    textDecoration: "underline",
    cursor: "pointer",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "calc(100% - 20px)",
  }),
  icon: {
    maxWidth: 16,
    minWidth: 16,
  },
  newTabIcon: {
    marginLeft: spacing(0.5),
  },
  deleteIcon: { padding: 0 },
  // Cell rows are tight — keep the copy button flush and scale its 24px glyph
  // down to the 16px the other cell icons use.
  copyLinkButton: {
    padding: 0,
    flexShrink: 0,
    "& svg": { width: 16, height: 16 },
  },
}));
export default styles;
